import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CONFIG-DRIVEN VERIFICATION PAGES
// Thin GET / PUT wrappers used by pages/Accounts/ConfigVerification.jsx. Each page's config
// (pages/Accounts/verificationConfigs.jsx) supplies the route (e.g. 'Accounts/VerifyShareIssuanceGrid')
// and parameters — the same legacy-backed routes a hand-written page would call.
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

export const getRoute = async (route, params) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${route}`, { params, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

export const postRoute = async (route, payload) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/${route}`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

export const putRoute = async (route, payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${route}`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
